import React from "react";
import { Select, MenuItem, FormControl, InputLabel, SelectChangeEvent } from "@mui/material";
import EquipmentTypes from "../../EquipmentTypes";

interface EquipmentTypeSelectClasses {
  root: string;
  label: string;
}

interface EquipmentTypeSelectProps {
  selection: string;
  setSelection?: (value: string) => void;
  assetTypeList: string[];
  disableBookingChanges?: boolean;
  classes: EquipmentTypeSelectClasses;
}

const EquipmentTypeSelect = ({selection, setSelection, assetTypeList, disableBookingChanges, classes}: EquipmentTypeSelectProps) => {

  const {OPTIONS} = EquipmentTypes;

  const handleChangeSelection = (event: SelectChangeEvent) => {
    setSelection?.(event.target.value)
  }

  return <FormControl className={classes.root}>
      <InputLabel id='ssEquipmentTypeLabel' className={classes.label}>Equipment Type</InputLabel>
      <Select
        value={selection || OPTIONS[0]}
        label="Equipment Type"
        onChange={handleChangeSelection}
        className='w-100'
        labelId="ssEquipmentTypeLabel"
        variant="standard"
        disabled={disableBookingChanges}
      >
        {
          assetTypeList?.map(item => (
            <MenuItem key={item} value={item}>{item}</MenuItem>
          ))
        }
      </Select>
    </FormControl>
}

export default EquipmentTypeSelect;
